export interface CreateRemoteFileRequestData {
  tenantId?: string;
  itemId?: string;
  title: string;
  url?: string;
  ttl: RemoteFileTTL;
}

export enum RemoteFileTTL {
  PERMANENT = 'PERMANENT',
  SHORT = 'SHORT',
}

export interface RemoteFile {
  id: string;
  title: string;
  url: string;
  ttl: RemoteFileTTL;
  preSignedUrl?: string;
  uploadTime?: number;
}
